import { Tag, Space, Tooltip } from 'antd';
import { useTranslation } from 'react-i18next';
import bio from '../../../img/product/bio.svg';
import editIcon from '../../../img/edit-icon.svg';

export const BiologicalLegend = ({ height = 18 }) => (
  <img src={bio} alt={'biologique'} style={{ height: height }} />
);

const TreatmentLegends = () => {
  const { t } = useTranslation('common');

  const legends = [
    {
      key: 'emballage',
      text: t('legends.emballage'),
      color: '#95DE64',
      textColor: '#000',
      tooltip: t('legends.emballageTooltip'),
    },
    {
      key: 'nouveau',
      text: t('legends.nouveau'),
      color: '#08979C',
      textColor: '#fff',
      tooltip: t('legends.nouveauTooltip'),
    },
    {
      key: 'serie',
      text: t('legends.serie'),
      color: '#135200',
      tooltip: t('legends.serieTooltip'),
    },
    {
      key: 'fin',
      text: t('legends.fin'),
      color: '#FFFFB8',
      textColor: '#000',
      tooltip: t('legends.finTooltip'),
    },
    {
      key: 'pfi',
      text: t('legends.pfi'),
      color: '#fff',
      textColor: '#135200',
      bordered: true,
      tooltip: t('legends.pfiTooltip'),
    },
    {
      key: 'urgence',
      text: t('legends.urgence'),
      color: '#08979C',
      textColor: '#fff',
      tooltip: t('legends.urgenceTooltip'),
    },
    {
      key: 'tolerance',
      text: t('legends.tolerance'),
      color: '#D48806',
      textColor: '#fff',
      tooltip: t('legends.toleranceTooltip'),
    },
  ];

  return (
    <div className="flex gap-4 items-center flex-wrap">
      <p className="text-[#000] text-[14px] font-medium">
        {t('legends.labels_title')}
      </p>
      <Space wrap size="small">
        <Tooltip
          title={t('legends.biologicalApprovalTooltip')}
          placement="top"
        >
          <div className="flex h-[38px] px-[6px] py-1 flex-col justify-center items-center gap-2 rounded cursor-help">
            <BiologicalLegend height={32} />
          </div>
        </Tooltip>
        {legends.slice(0, 4).map((legend) => (
          <Tooltip key={legend.key} title={legend.tooltip} placement="top">
            <Tag
              color={legend.color}
              className="rounded cursor-help text-[11px] font-bold"
              style={{
                color: legend.textColor,
                ...(legend.bordered && {
                  border: `1.5px solid ${legend.textColor}`,
                  background: legend.color,
                }),
              }}
            >
              {legend.text}
            </Tag>
          </Tooltip>
        ))}
        <Tooltip
          title={t('legends.editTooltip')}
          placement="top"
        >
          <div className="flex h-[28px] w-[28px] justify-center items-center rounded bg-[#FF4D4F] cursor-help">
            <img src={editIcon} alt="edit" className="w-4 h-4" />
          </div>
        </Tooltip>
        {legends.slice(4).map((legend) => (
          <Tooltip key={legend.key} title={legend.tooltip} placement="top">
            <Tag
              color={legend.color}
              className="rounded cursor-help text-[11px] font-bold"
              style={{
                color: legend.textColor,
                ...(legend.bordered && {
                  border: `1.5px solid ${legend.textColor}`,
                  background: legend.color,
                }),
              }}
            >
              {legend.text}
            </Tag>
          </Tooltip>
        ))}
      </Space>
    </div>
  );
};

export default TreatmentLegends;
